import { Box, Flex, Heading4, Icon, Modal, Text, Tooltip } from "@nulogy/components";
import React from "react";
import styled from "styled-components";

const FILL_IN_THE_GAP_TOOLTIP =
  "Use this mode to schedule a block to fit precisely within an existing gap, which could be a shift or a space between two blocks.";
const MULTI_SELECT_TOOLTIP =
  "Use this mode to move blocks across one or more lines. To clear your entire selection, click outside the selected area. To deselect a specific block, simply click on it again.";
// HACK: This requires a 16px margin bottom, but we can't control the margin.
// Since there is already an 8px margin, we add 8px padding.
const Heading = ({ children: heading }) => (
  <Heading4 fontWeight="medium" paddingBottom="x1">
    {heading}
  </Heading4>
);

const Item = ({ name, svgFile }) => (
  <Flex alignItems="center" paddingBottom="x1">
    <img alt={name} src={`./svg/components/pages/schedule/${svgFile}.svg`} />
    <Text marginLeft="x2">{name}</Text>
  </Flex>
);

const AlignedIcon = styled(Icon)`
  position: relative;
  top: 2px;
`;

export default function LegendModal({ isLegendModalOpen, setLegendModalOpen }) {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={isLegendModalOpen}
      maxWidth="817px"
      onRequestClose={() => setLegendModalOpen(false)}
      title="Legend"
    >
      <Flex data-testid="scheduling-guide-statuses" justifyContent="space-between" marginBottom="x2">
        <Box>
          <Heading>Statuses</Heading>
          <Item name="Fully Scheduled" svgFile="fully_scheduled" />
          <Item name="Underscheduled" svgFile="underscheduled" />
          <Item name="Overscheduled" svgFile="overscheduled" />
          <Item name="Completed" svgFile="completed" />
          <Item name="Cancelled" svgFile="cancelled" />
        </Box>

        <Box>
          <Heading>Indicators</Heading>
          <Item name="Note" svgFile="notes" />
          <Item name="Custom work order field" svgFile="custom-work-order-field" />
          <Item name="Flag" svgFile="flagged" />
          <Item name="Break" svgFile="break" />
          <Item name="Overdue" svgFile="overdue" />
          <Item name="Teardown time" svgFile="teardown-time" />
          <Item name="Unavailable for scheduling" svgFile="unavailable" />
        </Box>

        <Box>
          <Heading>Quick actions</Heading>
          <Item name="Fully schedule block" svgFile="fully-schedule" />
          <Item name="Add work order notes" svgFile="add-notes" />
        </Box>
      </Flex>
      <Box marginBottom="x1">
        <Heading>Keyboard shortcuts</Heading>
        <Shortcut tooltip={FILL_IN_THE_GAP_TOOLTIP}>
          Fill-in-the-gap mode: Activate by holding “Shift” when dragging.
        </Shortcut>
        <Shortcut tooltip={MULTI_SELECT_TOOLTIP}>
          Multi-select mode: Activate by holding “Control” then selecting blocks. For an Apple device, hold “Command ⌘”
          instead.
        </Shortcut>
      </Box>
    </Modal>
  );
}

function Shortcut({ children, tooltip }) {
  return (
    <Text mb="x2">
      {children}
      <Tooltip placement="bottom" tooltip={tooltip}>
        <AlignedIcon color="darkBlue" icon="help" ml="half" size="16px" />
      </Tooltip>
    </Text>
  );
}
